import { useRef, useState } from 'react'

function isUnset(value) {
    return value === '' || value == null
}

function sameValue(left, right) {
    if (isUnset(left) && isUnset(right)) {
        return true
    }

    return left === right
}

export default function useFieldStore({ store, onRefused }) {
    const [pending, setPending] = useState([])
    const [focused, setFocused] = useState(false)
    const valuesAtFocus = useRef({})

    const storeField = async (name, value) => {
        setPending((current) => [...current, name])

        try {
            await store({ [name]: value })
        }
        catch (error) {
            onRefused(error)
        }
        finally {
            setPending((current) => current.filter((item) => item !== name))
        }
    }

    const onFocus = (formik, name) => {
        valuesAtFocus.current[name] = formik.values[name]
        setFocused(true)
    }

    const onBlur = async (formik, name) => {
        setFocused(false)

        const value = formik.values[name]
        const before = name in valuesAtFocus.current
            ? valuesAtFocus.current[name]
            : formik.initialValues[name]
        delete valuesAtFocus.current[name]
        if (sameValue(value, before)) {
            return
        }

        await formik.setFieldTouched(name, true, false)
        const errors = await formik.validateForm(formik.values)
        if (errors?.[name] != null) {
            return
        }

        await storeField(name, value)
    }

    const onChoose = async (formik, name, value) => {
        if (sameValue(value, formik.initialValues[name])) {
            return
        }

        await formik.setFieldValue(name, value, false)
        await formik.setFieldTouched(name, true, false)
        const errors = await formik.validateForm({
            ...formik.values,
            [name]: value,
        })
        if (errors?.[name] != null) {
            return
        }

        await storeField(name, value)
    }

    return {
        pending,
        held: focused || pending.length > 0,
        onFocus,
        onBlur,
        onChoose,
    }
}
